var React = require('react');

function IcnUser (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19.7964 7.23591C19.7964 10.5666 17.1026 13.2666 13.7794 13.2666C10.4563 13.2666 7.76245 10.5666 7.76245 7.23591C7.76245 3.9052 10.4563 1.2052 13.7794 1.2052C17.1026 1.2052 19.7964 3.9052 19.7964 7.23591","stroke":"black","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M20.9679 14.2273C24.3757 16.5221 26.5589 20.4181 26.5589 24.8477V26.1819H1V24.8477C1 20.4181 3.2364 16.5222 6.64426 14.2273C6.75072 14.1739 6.9104 14.0672 6.9104 14.0672C8.45464 16.202 10.9571 17.5895 13.7794 17.5895C16.6014 17.5895 19.1041 16.2018 20.6483 14.0672C20.6485 14.0672 20.8614 14.1739 20.9679 14.2273H20.9679Z","stroke":"black","strokeMiterlimit":"10","key":1})]);
}

IcnUser.defaultProps = {"width":"28","height":"27","viewBox":"0 0 28 27","fill":"none"};

module.exports = IcnUser;

IcnUser.default = IcnUser;
